<template>
    <div class="flex">
        <el-select v-model="pro" placeholder="省" clearable filterable @change="_pro">
            <el-option v-for="(item, index) in pros" :key="index" :label="item.title" :value="item.id">
            </el-option>
        </el-select>
        <el-select v-model="city" placeholder="市" clearable filterable :disabled="(loading || !pro)" @change="_city">
            <el-option v-for="(item, index) in citys" :key="index" :label="item.title" :value="item.id">
            </el-option>
        </el-select>
        <el-select v-model="town" placeholder="区" clearable filterable :disabled="(loading || !city)" @change="_town">
            <el-option v-for="(item, index) in towns" :key="index" :label="item.title" :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    props: {
    },
    data() {
        return {
            pros: [],
            citys: [],
            towns: [],
            pro: '',
            city: '',
            town: '',
            loading: false
        }
    },
    created() {
        this._pros();
    },
    methods: {
        _pro(e) {
            this._citys(e);
            this.towns = [];
            this.city = '';
            this.town = '';
        },
        _city(e) {
            this._towns(e);
            this.town = '';
        },
        _town(e) {

            this.$emit('input', e);
        },
        _towns(pid) {
            this.loading = true;
            this.$http.post('region/list', {
                pid,
                limit: 100,
                order: {
                    myorder: 'asc',
                    id: 'asc'
                }
            }).then(res => {
                this.loading = false;
                if (res.code) {
                    this.towns = res.data.data;
                }
            })
        },
        _citys(pid) {
            this.loading = true;
            this.$http.post('region/list', {
                pid,
                limit: 100,
                order: {
                    myorder: 'asc',
                    id: 'asc'
                }
            }).then(res => {
                this.loading = false;
                if (res.code) {
                    this.citys = res.data.data;
                }
            })
        },
        _pros() {
            this.loading = true;
            this.$http.post('region/list', {
                pid: 0,
                limit: 100,
                order: {
                    myorder: 'asc',
                    id: 'asc'
                }
            }).then(res => {
                this.loading = false;
                if (res.code) {
                    this.pros = res.data.data;
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@import "index.scss";
</style>